import { useState } from 'react';
import { useParentSessionsForMonth } from '@/hooks/use-parent-data';
import { SessionCalendar } from '@/components/shared/session-calendar';

export default function ParentCalendarPage() {
  const [calendarMonth, setCalendarMonth] = useState(() => new Date());

  const { data: monthData } = useParentSessionsForMonth(
    calendarMonth.getFullYear(),
    calendarMonth.getMonth()
  );

  const handleMonthChange = (year: number, month: number) => {
    setCalendarMonth(new Date(year, month, 1));
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-foreground">Calendar</h1>

      <SessionCalendar
        sessions={monthData?.sessions ?? []}
        isLoading={!monthData}
        onMonthChange={handleMonthChange}
        variant="parent"
      />
    </div>
  );
}
